
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { Autocomplete, TextField, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';


// ----------------------------------------------------------------------

const GroupHeader = styled('div')(({ theme }) => ({
  position: 'sticky',
  top: '-1px',
  padding: '4px 10px',
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  fontWeight: "bold",
}));

const GroupItems = styled('div')({
  '& .MuiAutocomplete-option': {
    paddingLeft: '20px'
  }
});

const TextFieldCustom = styled(TextField)({
  "& .MuiAutocomplete-input": {
    padding: "6px 9px !important",  // Example color override

  }
});



export default function RHFSelect({ name, disabled = false, disableClearable = false, options, groupBy = false, handleSelectChange }) {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          {...field}
          disabled={disabled}
          options={options}
          groupBy={(option) => groupBy && option.type}
          getOptionLabel={(option) => option.label ? option.label : ''}
          onChange={(event, newValue) => {
            if (handleSelectChange)
              handleSelectChange(newValue);
            field.onChange(newValue);
          }}
          value={field.value || null}
          disableClearable={disableClearable}
          isOptionEqualToValue={(option, value) => option.value === value.value}
          renderOption={(props, option) => (
            <span {...props}>
              {option.label}
            </span>
          )}

          renderInput={(params) => error ? <Tooltip placement="right" title={error.message}>
            <TextFieldCustom placeholder=""  {...params} error={!!error} />
          </Tooltip> : <TextFieldCustom placeholder=""  {...params} />

          }

          renderGroup={(params) => (
            <li key={params.key}>
              {(params.group) && <GroupHeader>{params.group}</GroupHeader>}
              <GroupItems>{params.children}</GroupItems>
            </li>
          )}

        />

      )
      }
    />
  );
}
